import React, { useEffect, useState, useMemo, useRef } from 'react';
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';

import '../styles/Home.css';
import '../styles/Membership.css';
import '../styles/Contact.css'
import Footer from '../components/Footer';

export default function Membership() {
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [selectedFAQ, setSelectedFAQ] = useState(0);

  

  return (
    <div className='container'>
      <div className='membership-header-container'>
        <div className='membership-header-title'>CANTO <span>Membership</span></div>
        <div className='membership-header-text'>
          CANTO is pleased to invite your company to join the organization as an active member and be part of a growing empire as we take you into the 21st Century. Over the past twenty-seven years our membership has grown from eight (8) members in eight (8) countries to one hundred and ten members (110) in 32  countries.
        </div>
      </div>

      <div className='membership-info'>
        <div>
          
        </div>
      </div>

      

    </div>
  )
}
